import React from 'react';
import { Card, Table, Button, Space, Tag, Alert } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const Desktop = ({ viewModel }) => {
    const { list, setting, settingLoaded, onAdd, onEdit, onDelete, navigate, MODE_LABELS, APPLY_LABELS } = viewModel;

    const columns = [
        { title: 'Tên bảng giá', dataIndex: 'name', key: 'name' },
        {
            title: 'Chế độ', dataIndex: 'mode', key: 'mode',
            render: (mode) => <Tag>{MODE_LABELS[mode] ?? mode}</Tag>,
        },
        {
            title: 'Áp dụng', dataIndex: 'apply_to', key: 'apply_to',
            render: (v) => APPLY_LABELS[v] ?? v,
        },
        {
            title: '', key: 'actions',
            render: (_, row) => (
                <Space>
                    <Button size="small" onClick={() => onEdit(row.id)}>Sửa</Button>
                    <Button size="small" danger onClick={() => onDelete(row.id)}>Xoá</Button>
                </Space>
            ),
        },
    ];

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            {settingLoaded && !setting.enabled && (
                <Alert
                    message="Tính năng bảng giá chưa được bật."
                    description={<span>Vào <a onClick={() => navigate('/setting/pricing-tables')}>Cài đặt → Bảng giá khách hàng</a> để bật.</span>}
                    type="warning"
                    showIcon
                />
            )}
            <Card
                title="Danh sách bảng giá"
                extra={<Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>Thêm bảng giá</Button>}
            >
                <Table
                    rowKey="id"
                    dataSource={list}
                    columns={columns}
                    pagination={false}
                />
            </Card>
        </Space>
    );
};

export default Desktop;
